import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'query-string';

import { financeApi } from '~/api/finance/financeApi';
import { AssetBalanceParams, PayEntitiesEnum } from '~/api/finance/financeApiTypes';
import { getBalance } from '~/atomic/page/finance/financePage.data';
import { financePageSliceName } from '~/atomic/page/finance/financePage.slice';
import { getOperations } from '~/atomic/page/finance/OperationsTable/operationTable.data';
import { paymentTransaction } from '~/feature/book/paymentResult/paymentResult.data';
import { paymentResultActions } from '~/feature/book/paymentResult/paymentResult.slice';
import { accountReplenishmentActions } from '~/feature/finance/accountReplenishment/accountReplenishment.slice';
import { me } from '~/feature/user/user.data';
import { environments } from '~/lib/const';
import { RootState } from '~/store';

export interface RegisterAssetBalanceThunkParams extends AssetBalanceParams {
  queries?: {
    name: string;
    value: string | number;
  }[];
  successTransaction?: () => void;
}

export const registerAssetBalance = createAsyncThunk<
void,
RegisterAssetBalanceThunkParams, {
  rejectValue: { error: string }; state: RootState
}>(
  `${financePageSliceName}/registerRewardBook`,
  async (
    data,
    thunkAPI,
  ) => {
    try {
      const currentUrl = qs.parseUrl(String(window.location));
      const returnUrl = qs.parseUrl(currentUrl.url);

      returnUrl.query.payEntity = PayEntitiesEnum.AssetBalance;
      returnUrl.query.methodPayment = data.methodPayment;
      returnUrl.query.transactionId = 'TIDSET';

      if (data?.queries?.length) {
        data.queries?.forEach((query) => {
          (returnUrl.query as any as string)[query.name] = query.value;
        });
      }

      const result = await financeApi.assetBalance({
        ...data,
        returnUrl: qs.stringifyUrl(returnUrl),
      });

      if (result && 'data' in result) {
        await thunkAPI.dispatch(
          paymentTransaction({
            ...result.data,
            successTransactionHandler: async () => {
              thunkAPI.dispatch(me());
              thunkAPI.dispatch(getBalance());
              thunkAPI.dispatch(getOperations({}));
              thunkAPI.dispatch(paymentResultActions.openModal('assetBalanceSuccess'));
              thunkAPI.dispatch(accountReplenishmentActions.setIsOpenModal(false));
              if (data.successTransaction) {
                await data.successTransaction();
              }
            },
          }),
        );
      }
    } catch (error) {
      if (data.bankCardId) {
        thunkAPI.dispatch(paymentResultActions.openModal('assetBalanceReject'));
      }
      if (environments.isClient && error instanceof Error) {
        const { message } = await import('~/atomic/atom/message');
        message.error(error.message);

        return thunkAPI.rejectWithValue({ error: error.message });
      }
    }
  },
);
